import { z } from 'zod';

/**
 * Uploaded files are served from this app, so their "url" is an app-relative
 * path (`/api/uploads/<id>`). Absolute URLs stay allowed for anything already
 * hosted elsewhere. Used by leave attachments and `files` column values.
 */
export const UrlOrPath = z.string().refine(
  (v) => v.startsWith('/') || z.string().url().safeParse(v).success,
  { message: 'Must be an absolute URL or an app-relative path' },
);
